import { render, staticRenderFns } from "./TokenMovements.vue?vue&type=template&id=48fc7c41&scoped=true&"
import script from "./TokenMovements.vue?vue&type=script&lang=js&"
export * from "./TokenMovements.vue?vue&type=script&lang=js&"
import style0 from "./TokenMovements.vue?vue&type=style&index=0&id=48fc7c41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fc7c41",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardTitle,VContainer,VDataTable,VSelect,VTextField})
